import { get } from 'vuex-pathify';
export default {
  computed: {
    attachmentsDataSourceName: get('admin/modulesMapping@documentation.attachment_datasource_name'),
    openAttachmentsDialogButton() {
      return this.attachmentsAndCommentsPermission > 0 && this.hasAttachments
        ? [
            {
              name: 'openAttachmentsDialog',
              icon: 'mdi-paperclip',
              tooltip: this.isAnyFeatureSelected
                ? this.$i18n.t('button.addAttachments')
                : this.$i18n.t('button.toAddAttachemnts', {
                    suffix: this.$i18n.t('button.atLeastOneSelected'),
                  }),
              fontSize: '19px',
              disabled: !this.isAnyFeatureSelected,
            },
          ]
        : [];
    },
    attachmentsAndCommentsPermission() {
      return this.permissions[this.currentLayer.id].attachments_and_comments_value;
    },
    vehiclesDataSourceName: get('admin/modulesMapping@vehicles.datasource_name'),
    nonAttachmentsDataSources() {
      return [this.attachmentsDataSourceName, this.vehiclesDataSourceName];
    },
    hasAttachments() {
      return !this.nonAttachmentsDataSources.includes(this.currentLayerDataSourceName);
    },
    selectedFeaturesForAttachments() {
      return (this.currentLayerSelectedFeatures || []).map(r => ({
        datasource_name: this.currentLayerDataSourceName,
        id: r,
      }));
    },
  },
  data: () => ({
    isAttachmentDialogLoaded: false,
    isAttachmentVisible: false,
  }),
  methods: {
    openAttachmentsDialogAction() {
      this.isAttachmentDialogLoaded = true;
      this.isAttachmentVisible = true;
    },
  },
};
